/**
 * @generated SignedSource<<a47183f377827441d9c91b7504c70c7f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type priorityGroupHeader_issueTableGrouping$data = {
  readonly displayName: string;
  readonly priority: {
    readonly iconUrl: AGG$URL | null | undefined;
  };
  readonly " $fragmentType": "priorityGroupHeader_issueTableGrouping";
};
export type priorityGroupHeader_issueTableGrouping$key = {
  readonly " $data"?: priorityGroupHeader_issueTableGrouping$data;
  readonly " $fragmentSpreads": FragmentRefs<"priorityGroupHeader_issueTableGrouping">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "priorityGroupHeader_issueTableGrouping",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "displayName"
    },
    {
      "concreteType": "JiraPriority",
      "kind": "LinkedField",
      "name": "priority",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "iconUrl"
        }
      ]
    }
  ],
  "type": "JiraJqlPriorityFieldValue"
};

(node as any).hash = "3dcfc9ec9cb74efd76e969db691aec34";

export default node;
